import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { MessageCircle } from 'lucide-react';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';

/**
 * Opens (or reuses) an internal chat thread between the current buyer and the
 * seller. Falls back to /login if the user is anonymous. `productId` is
 * optional and, when present, adds context to the created thread.
 */
export const ContactSellerButton = ({ sellerId, productId, sellerName, className = '', dataTestId }) => {
  const { user } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  const open = async () => {
    if (!user) { nav('/login'); return; }
    if (user.role === 'seller' && user.user_id === sellerId) {
      toast.info('No puedes chatear contigo mismo.'); return;
    }
    setBusy(true);
    try {
      const { data } = await api.post('/chat/threads', { seller_id: sellerId, product_id: productId });
      nav(`/mensajes?open=${data.thread.thread_id}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'No se pudo abrir el chat');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); open(); }}
      disabled={busy}
      data-testid={dataTestId || 'contact-seller-btn'}
      className={`inline-flex items-center gap-1 text-slate-900 hover:text-orange-600 font-semibold transition-colors ${className}`}
    >
      <MessageCircle className="h-4 w-4" />
      {busy ? 'Abriendo…' : (sellerName ? `Contactar ${sellerName}` : 'Contactar vendedor')}
    </button>
  );
};
